import React from 'react';

const UserContext = React.createContext({
  org: null,
  userData: null,
});

export default UserContext;
